var path = 'areas/projects/actions/wildfly/Octopus.WildFlyState_edit.html';
var html = "<div> <p class=help-block> This step is used to enable or disable deployments in WildFly or Red Hat JBoss EAP. </p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/wildfly/Octopus.WildFlyState_edit.html
// module id = 7586921368715206
// module chunks = 1